const getPriceWithCurrency = (value: number) =>
    new Intl.NumberFormat('fr', { style: 'currency', currency: 'EUR' }).format(value).replace(',', '.');
  
  export default getPriceWithCurrency;
  